//frontend/src/pages/Auth.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';


function Auth() {
    const { t } = useTranslation();

    const navigate = useNavigate();

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Typography variant="h5" sx={{ mb: 2, textAlign: 'center' }}>
            {t('auth.register.title')}
                        </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={() => navigate('/login')}
                >

                    {t('common.login')}

                </Button>
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => navigate('/register')}
                >
                    
                    {t('common.register')}

                </Button>
            </Box>
        </Container>
    );
}

export default Auth;
